<template>
  <div>
    <!-- Hero Section -->
    <div class="hero-section position-relative">
      <div class="hero-overlay"></div>
      <div class="hero-image-container">
        <img src="@/assets/porto-service2.jpg" alt="Porto Service" class="hero-image">
      </div>
      <div class="container-fluid px-4 h-100">
        <div class="row h-100 align-items-center">
          <div class="col-12 text-center text-white position-relative">
            <h1 class="display-2 fw-bold mb-4">Sobre Nós</h1>
            <p class="lead mb-4">Conheça a Hammer Naval e nossa história de excelência</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Missão e Visão e Valores -->
    <div class="py-4">
      <div class="container-fluid px-4">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-5 text-center">
                <div class="mb-4">
                  <i class="bi bi-flag text-primary display-4"></i>
                </div>
                <h2 class="h3 mb-4">Nossa Missão</h2>
                <p class="mb-0">Contribuir em parceria com os
                      nossos clientes para o
                      desenvolvimento perene da
                      indústria naval brasileira.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-5 text-center">
                <div class="mb-4">
                  <i class="bi bi-eye text-primary display-4"></i>
                </div>
                <h2 class="h3 mb-4">Nossa Visão</h2>
                <p class="mb-0">Ser uma empresa de referência
                                na indústria naval com foco na
                                tecnologia, desenvolvimento e
                                sustentabilidade.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-5 text-center">
                <div class="mb-4">
                  <i class="bi bi-award text-primary display-4"></i>
                </div>
                <h2 class="h3 mb-4">Nossos Valores</h2>
                <p class="mb-0">Excelência, comprometimento,
                                adaptabilidade, foco,
                                integridade, honestidade,
                                transparência, segurança,
                                qualidade e dedicação.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Valores -->
    <!-- <div class="bg-light py-6">
      <div class="container-fluid px-4">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <h2 class="display-4 mb-4">Nossos Valores</h2>
            <p class="lead">Os princípios que norteiam nossa atuação</p>
          </div>
        </div>
        <div class="row g-4">
          <div class="col-md-3">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-4 text-center">
                <div class="mb-3">
                  <i class="bi bi-shield-check text-primary display-4"></i>
                </div>
                <h3 class="h5 mb-3">Segurança</h3>
                <p class="mb-0">Prioridade máxima em todas as operações</p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-4 text-center">
                <div class="mb-3">
                  <i class="bi bi-award text-primary display-4"></i>
                </div>
                <h3 class="h5 mb-3">Excelência</h3>
                <p class="mb-0">Busca constante pela qualidade</p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-4 text-center">
                <div class="mb-3">
                  <i class="bi bi-lightbulb text-primary display-4"></i>
                </div>
                <h3 class="h5 mb-3">Inovação</h3>
                <p class="mb-0">Soluções criativas e modernas</p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-4 text-center">
                <div class="mb-3">
                  <i class="bi bi-people text-primary display-4"></i>
                </div>
                <h3 class="h5 mb-3">Compromisso</h3>
                <p class="mb-0">Dedicação aos nossos clientes</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- História -->
    <div class="py-6">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-4 mb-lg-0">
            <img src="@/assets/nossa-historia.png" alt="Nossa História" class="img-fluid rounded shadow-lg">
          </div>
          <div class="col-lg-6">
            <h2 class="display-4 mb-4">Nossa História</h2>
            <p class="lead mb-4">Uma trajetória de sucesso no setor naval</p>
            <p class="mb-4">A HAMMER NAVAL unificou o conhecimento de gestão
                de negócios com a engenharia naval.
                Os sócios fundadores somam mais de 20 anos de
                experiência no mercado industrial internacional. O
                diretor técnico e responsável técnico é Engenheiro
                Naval, mestrando em Máquinas Marítimas pela UFRJ,
                possui mais de 400 ART (Anotações de
                Responsabilidade Técnica) emitidas perante o CREA
                SC, são diversos projetos concebidos e executados na
                área naval desde construção offshore à obras
                hidroviárias, passando por empresas nacionais e
                multinacionais.
                O diretor administrativo possui um conglomerado de
                10 empresas, atuando como empresário e
                empreendedor, desde o ano de 2008 com diversos
                agentes da indústria global.</p>
            <p>Ao longo dos anos, construímos uma reputação sólida baseada na qualidade dos nossos serviços e no compromisso com a segurança e satisfação dos nossos clientes.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sobre'
}
</script>

<style scoped>
.hero-section {
  height: 60vh;
  min-height: 500px;
  overflow: hidden;
}

.hero-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.1);
  animation: zoomEffect 20s infinite alternate ease-in-out;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.4)
  );
  z-index: 1;
}

.container-fluid {
  position: relative;
  z-index: 2;
}

@keyframes zoomEffect {
  from {
    transform: scale(1.1);
  }
  to {
    transform: scale(1.2);
  }
}

.py-6 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.card {
  transition: transform 0.3s ease;
  background-color: #fff;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.bi {
  transition: transform 0.3s ease;
}

.card:hover .bi {
  transform: scale(1.1);
}

.bg-light {
  background-color: #fff !important;
}

/* Ajustes responsivos */
@media (max-width: 991.98px) {
  .hero-section {
    height: 50vh;
    min-height: 400px;
  }

  .display-2 {
    font-size: 3rem;
  }

  .display-4 {
    font-size: 2.5rem;
  }

  .card-body {
    padding: 2rem !important;
  }
}

@media (max-width: 767.98px) {
  .hero-section {
    height: 40vh;
    min-height: 300px;
  }

  .hero-section h1 {
    font-size: 2.5rem;
  }

  .hero-section .lead {
    font-size: 1.1rem;
  }

  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .card-body {
    padding: 1.5rem !important;
  }
}
</style> 